module.exports = __webpack_public_path__ + "img/new_onerequest_600.693885ef.png";